import React from "react";
import { makeStyles } from '@material-ui/core/styles';

import Container from "../../../../base/components/container.js";
import ButtonLink from "../../../../base/links/button_link.js";
import I18n from "../../../../base/i18n.js.jsx";

import BlockHeader from "./block_header.js";
import IcHouse from "../resources/icons/ic_house.js";
import IcPercents from "../resources/icons/ic_percents.js"
import IcCalendar from "../resources/icons/ic_calendar.js"

import Routes from "../../../routes.js";

const blockStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.white,
  },
  content: {
    padding: "36px 0px 60px",
    ['@media (max-width: 768px)']: {
      padding: "34px 24px 40px",
    },
  },
  text: {
    display: "block",
    fontWeight: theme.typography.fontWeightLight,
    fontSize: "20px",
    textAlign: "center",
    marginBottom: "36px",
    ['@media (max-width: 992px)']: {
      fontSize: "18px",
      marginBottom: "34px",
    },
    ['@media (max-width: 768px)']: {
      fontSize: "14px",
      lineHeight: "20px",
      textAlign: "left",
      marginBottom: "32px",
    },
  },
  columnsContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "50px",
    ['@media (max-width: 992px)']: {
      justifyContent: "center",
    },
    ['@media (max-width: 768px)']: {
      flexWrap: "wrap",
      marginBottom: "40px",
    },
  },
  column: {
    padding: "0px 25px",
    "&:first-child": {
      paddingLeft: "0px"
    },
    "&:last-child": {
      paddingRight: "0px"
    },
    display: "flex",
    flexDirection: "column",
    ['@media (max-width: 992px)']: {
      width: "100%",
    },
    ['@media (max-width: 768px)']: {
      flexDirection: "row",
      padding: "0px 0px",
      marginBottom: "30px",
      "&:last-child": {
        marginBottom: "0px"
      },
    },
  },
  columnIcon: {
    width: "70px",
    height: "70px",
    flexBasis: "70px",
    flexShrink: "0",
    marginBottom: "32px",
    ['@media (max-width: 992px)']: {
      flexBasis: "50px",
      width: "50px",
      height: "50px",
      marginBottom: "24px",
    },
    ['@media (max-width: 768px)']: {
      flexBasis: "30px",
      width: "30px",
      height: "30px",
      marginBottom: "0px",
      marginRight: "19px"
    },
  },
  icon: {
    width: "100%",
    height: "100%"
  },
  columnContent: {
    display: "flex",
    flexDirection: "column"
  },
  columnTitle: {
    display: "block",
    fontSize: "24px",
    textTransform: "uppercase",
    marginBottom: "18px",
    ['@media (max-width: 992px)']: {
      fontSize: "20px",
      marginBottom: "16px",
    },
    ['@media (max-width: 768px)']: {
      fontSize: "14px",
      lineHeight: "18px",
      marginBottom: "14px",
    },
  },
  columnText: {
    display: "block",
    fontWeight: theme.typography.fontWeightLight,
    fontSize: "20px",
    ['@media (max-width: 992px)']: {
      fontSize: "18px",
    },
    ['@media (max-width: 768px)']: {
      fontSize: "14px",
      lineHeight: "20px",
    },
  },
  learnMoreContainer: {
    display: "flex",
    justifyContent: "center",
  },
  learnMore: {
    width: "100%",
    maxWidth: "312px"
  }
}));

const FinancingBlock = () => {
  const classes = blockStyles();

  const columns = [
    {
      icon: <IcHouse className = { classes.icon } />,
      title: I18n.t("web.page.index.financing.simply_invest.title"),
      text: I18n.t("web.page.index.financing.simply_invest.text")
    },
    {
      icon: <IcPercents className = { classes.icon } />,
      title: I18n.t("web.page.index.financing.high_interests_rates.title"),
      text: I18n.t("web.page.index.financing.high_interests_rates.text")
    },
    {
      icon: <IcCalendar className = { classes.icon } />,
      title: I18n.t("web.page.index.financing.short_term.title"),
      text: I18n.t("web.page.index.financing.short_term.text")
    }
  ]

  return (
    <div className = { classes.root } >
      <Container className = { classes.content }>
        <BlockHeader>
          { I18n.t("web.page.index.financing.title") }
        </BlockHeader>
        <span className = { classes.text } >
          { I18n.t("web.page.index.financing.text") }
        </span>
        <div className = { classes.columnsContainer } >
          {
            columns.map((column, index) => {
              const { icon, title, text } = column;
              return <div className = { classes.column }
                          key = { index } >
                <div className = { classes.columnIcon } >
                  { icon }
                </div>
                <div className = { classes.columnContent } >
                  <span className = { classes.columnTitle } >
                    { title }
                  </span>
                  <span className = { classes.columnText } >
                    { text }
                  </span>
                </div>
              </div>
            })
          }
        </div>
        <div className = { classes.learnMoreContainer } >
          <ButtonLink className = { classes.learnMore }
                      to = { Routes.howItWorks() } >
            { I18n.t("action.learn_more") }
          </ButtonLink>
        </div>
      </Container>
    </div>
  );
}

export default FinancingBlock;